import { schema } from 'normalizr';
import { ENTITY_TYPES } from 'containers/App/modules/entities/entities.constants';


const userGroup = new schema.Entity(ENTITY_TYPES.USER_GROUPS);
const country = new schema.Entity(ENTITY_TYPES.COUNTRIES);
const deviceType = new schema.Entity(ENTITY_TYPES.DEVICE_TYPES, {}, {
	idAttribute: (value, parent, key) => value.type
});

const user = new schema.Entity(ENTITY_TYPES.USERS, {
	group: userGroup
}, {
	/*mergeStrategy: (entityA, entityB) => {
		return {
			...entityA,
			...entityB,
		}
	}*/
});

user.define({
	manager: user
});

const customerDetails = new schema.Entity(ENTITY_TYPES.CUSTOMER_DETAILS);

const device = new schema.Entity(ENTITY_TYPES.DEVICES, {
	customerDetails: customerDetails,
	deviceType: deviceType
});

const group = new schema.Entity('groups');

const swVersion = new schema.Entity('swVersions');

const lumenisXVersion = new schema.Entity('lumenisXVersions');

const v2cHistory = new schema.Entity('v2c');

const alarms = new schema.Entity('alarms');

const deviceAlarms = new schema.Entity('deviceAlarms');

const deviceFiles = new schema.Entity('deviceFiles');

const licenses = new schema.Entity('licenses');

const securityVersions = new schema.Entity('securityVersions');

const securityVersionHistories = new schema.Entity('securityVersionHistories');

// CRC failure events (processing service)
const crcFailureEvents = new schema.Entity('crcFailureEvents');

// Telemetry events (processing service)
const events = new schema.Entity(ENTITY_TYPES.EVENTS, {}, {
	idAttribute: 'entryId'
});

const entitySchemas = {
	userGroup,
	country,
	deviceType,
	user,
	customerDetails,
	device,
	group,
	swVersion,
	lumenisXVersion,
	v2cHistory,
	alarms,
	deviceAlarms,
	deviceFiles,
	licenses,
	securityVersions,
	securityVersionHistories,
	crcFailureEvents,
	events
};

export default entitySchemas;
